import { render, staticRenderFns } from "./PopupRiskInfo.vue?vue&type=template&id=8fbb9cda&scoped=true"
import script from "./PopupRiskInfo.vue?vue&type=script&lang=js"
export * from "./PopupRiskInfo.vue?vue&type=script&lang=js"
import style0 from "./PopupRiskInfo.vue?vue&type=style&index=0&id=8fbb9cda&prod&lang=scss&scoped=true"
import style1 from "./PopupRiskInfo.vue?vue&type=style&index=1&id=8fbb9cda&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fbb9cda",
  null
  
)

export default component.exports